<template>
  <div class="modal-backdrop" @click.self="closeModel">
    <v-overlay v-if="showOverlay" v-model="overlay" persistent></v-overlay>
    <div
      :style="{
        gap: gap ? gap : '0px',
        padding: padding ? padding : '0px',
        borderRadius: borderRadius ? borderRadius : '10px',
        'padding-top': paddingTop ? paddingTop : 'unset',
      }"
      class="modal-container"
    >
      <v-icon
        v-if="showCloseBtn"
        class="close-icon"
        @click="closeModel"
        :size="isMobile ? 35 : 40"
        icon="mdi-close"
        color="#959595"
      />
      <div class="d-flex flex-column align-center">
        <v-icon
          v-if="icon"
          :size="iconSize"
          :color="iconColor"
          :icon="icon"
        ></v-icon>
        <div v-if="title" class="title">{{ title }}</div>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  emits: ["close"],
  props: {
    iconSize: {
      type: String,
      default: "40px",
    },
    title: {
      type: String,
    },
    icon: {
      type: String,
    },
    iconColor: {
      type: String,
    },
    gap: {
      type: String,
    },
    padding: {
      type: String,
    },
    borderRadius: {
      type: String,
    },
    paddingTop: {
      type: String,
    },
    showCloseBtn: {
      type: Boolean,
      default: true,
    },
    showOverlay: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      overlay: true,
    };
  },
  computed: {
    ...mapGetters({
      isMobile: "isMobile",
      isLaptop: "isLaptop",
      isTablet: "isTablet",
      isDesktop: "isDesktop",
    }),
  },
  methods: {
    closeModel() {
      this.overlay = false;
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-container {
  position: relative;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: 90vh;
  width: auto;
  max-width: 90vw;
  overflow: visible; /* Changed from auto to visible */
}

.close-icon {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 1;
  cursor: pointer;
}

.title {
  text-align: center;
  font-size: 22px;
  font-weight: 700;
  color: #434343;
}

@media (max-width: 601px) {
  .modal-container {
    width: 90%;
  }
}

/* Scrollbar styling */
.modal-container::-webkit-scrollbar {
  width: 8px;
}

.modal-container::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.modal-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.modal-container {
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
}
</style>